import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VerticalSpaceTarget } from 'app/spaces/planograms-editor/store/planogram.store.state';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';

export type ShelfVerticalSpaceDialogMode = 'HEIGHT' | 'ADD' | 'REMOVE';

export interface SpcShelfVerticalSpaceReassignData {
  mode: ShelfVerticalSpaceDialogMode;
  hasUpperNeighbor: boolean;
  hasLowerNeighbor: boolean;
}

@Component({
  template: `
    <h1 mat-dialog-title>{{ title }}</h1>
    <div mat-dialog-content>
      <p>{{ message }}</p>
      <mat-radio-group class="shelf-space-target-group" [(ngModel)]="selected">
        <mat-radio-button *ngIf="data.hasUpperNeighbor" [value]="'UPPER_SHELF'">
          {{ 'SPACES.EDITOR.SHELF_SPACE_REASSIGN_UPPER' | pTranslate }}
        </mat-radio-button>
        <mat-radio-button *ngIf="data.hasLowerNeighbor" [value]="'LOWER_SHELF'">
          {{ 'SPACES.EDITOR.SHELF_SPACE_REASSIGN_LOWER' | pTranslate }}
        </mat-radio-button>
        <mat-radio-button [value]="'MODULE_HEIGHT'">
          {{ 'SPACES.EDITOR.SHELF_SPACE_REASSIGN_MODULE' | pTranslate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div mat-dialog-actions fxLayoutAlign="end">
      <button mat-button (click)="close()">
        {{ 'SPACES.EDITOR.BTN_CANCEL' | pTranslate }}
      </button>
      <button mat-button cdkFocusInitial color="accent" (click)="accept()" [disabled]="!selected">
        {{ 'SPACES.EDITOR.BTN_ACEPT' | pTranslate }}
      </button>
    </div>
  `,
  styles: [
    `
      .shelf-space-target-group {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-top: 8px;
      }
    `,
  ],
})
export class SpcShelfVerticalSpaceReassignDialog {
  selected: VerticalSpaceTarget | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SpcShelfVerticalSpaceReassignData,
    public dialogRef: MatDialogRef<SpcShelfVerticalSpaceReassignDialog>,
    public translate: IanTranslateService
  ) {
    dialogRef.disableClose = true;
  }

  get title(): string {
    return this.translate.instant('SPACES.EDITOR.SHELF_SPACE_REASSIGN_TITLE', null, 'Reasignar espacio vertical');
  }

  get message(): string {
    const key =
      this.data.mode === 'ADD'
        ? 'SPACES.EDITOR.SHELF_SPACE_REASSIGN_ADD_MESSAGE'
        : this.data.mode === 'REMOVE'
        ? 'SPACES.EDITOR.SHELF_SPACE_REASSIGN_REMOVE_MESSAGE'
        : 'SPACES.EDITOR.SHELF_SPACE_REASSIGN_HEIGHT_MESSAGE';

    return this.translate.instant(key, null, 'Elegí de dónde sale o a dónde va el espacio vertical.');
  }

  accept(): void {
    if (!this.selected) return;
    this.dialogRef.close(this.selected);
  }

  close(): void {
    this.dialogRef.close(null);
  }
}
